export default __webpack_public_path__ + "static/media/n2.3.160fb255.jpeg";